var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "grey-text text-left text-darken-2" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("file.messages.selectApplicationToUpload.0")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("v-client-table", {
        staticClass: "vue-custom-table no-pagination",
        attrs: {
          data: _vm.files,
          columns: _vm.table.columns,
          options: _vm.table.options,
        },
        scopedSlots: _vm._u([
          {
            key: "h__selected",
            fn: function () {
              return [
                _c("div", { staticClass: "form-group-checkbox" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "pretty p-icon p-jelly p-smooth p-curve mr-0",
                    },
                    [
                      _c("input", {
                        ref: "selectAll",
                        staticClass: "checkbox",
                        attrs: { type: "checkbox" },
                        domProps: { checked: _vm.allFilesSelected },
                        on: { click: _vm.handleSelectAllFiles },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "state p-success" }, [
                        _c("i", { staticClass: "icon fa fa-check" }),
                        _vm._v(" "),
                        _c("label", {
                          staticClass: "text-light-gray",
                          attrs: { for: "select-all" },
                        }),
                      ]),
                    ]
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "selected",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", { staticClass: "form-group-checkbox" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "pretty p-icon p-jelly p-smooth p-curve mr-0",
                    },
                    [
                      _c("input", {
                        staticClass: "checkbox",
                        attrs: {
                          type: "checkbox",
                          "true-value": "true",
                          name: "select-file-" + row.id,
                        },
                        domProps: { checked: _vm.isFileSelected(row.id) },
                        on: {
                          click: function ($event) {
                            return _vm.handleSelectFile(row)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "state p-success" }, [
                        _c("i", { staticClass: "icon fa fa-check" }),
                        _vm._v(" "),
                        _c("label", {
                          attrs: { for: "select-file-" + row.id },
                        }),
                      ]),
                    ]
                  ),
                ]),
              ]
            },
          },
          {
            key: "fileName",
            fn: function (ref) {
              var row = ref.row
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("truncateFileName")(row.filename, 25)) +
                    "\n    "
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }